import { RectangleF } from "./rectangle-f";

export enum GraphicsInfoFieldType {
  Text = 1,
  Media,
  Color,
  Scale,
  Position,
}

export enum GraphicsInfoTextAlign {
  Left = 1,
  Center = 2,
  Right = 3,
}

export enum GraphicsInfoMediaType {
  None,
  MediaId,
  DynamicOption,
  Link,
}

export enum MediaType {
  Image = 1,
  Video = 2,
}

export enum GraphicsInfoMediaFit {
  IgnoreAspect = 1,
  LetterBox,
  StretchToCover,
}

export abstract class GraphicsInfoField {
  constructor(
    public id: number,
    public label: string,
  ) {}
}

export class GraphicsInfoTextField extends GraphicsInfoField {
  constructor(
    id: number,
    label: string,
    public text: string,
    public link: string,
    public fontId: number,
    public size: number,
    public color: string,
    public align: GraphicsInfoTextAlign,
    public dynamicOptions: [number],
    public shrinkToFit: boolean,
    public isTicker: boolean,
    public tickerSpeed: number,
    public tickerDirection: number,
    public tickerIsLoop: boolean,
  ) {
    super(id, label);
  }
}

export class GraphicsInfoMediaField extends GraphicsInfoField {
  constructor(
    id: number,
    label: string,
    public mediaId: number,
    public mediaType: GraphicsInfoMediaType,
    public link: string,
    public dynamic: string,
    public fitMedia: GraphicsInfoMediaFit,
    public imageOrVideo: MediaType,
  ) {
    super(id, label);
  }
}

export class GraphicsInfoColorField extends GraphicsInfoField {
  constructor(
    id: number,
    label: string,
    public value: Array<string>,
  ) {
    super(id, label);
  }
}

export class GraphicsInfoScaleField extends GraphicsInfoField {
  constructor(
    id: number,
    label: string,
    public value: number,
  ) {
    super(id, label);
  }
}

export class GraphicsInfoPositionField extends GraphicsInfoField {
  constructor(
    id: number,
    label: string,

    public value: number,
  ) {
    super(id, label);
  }
}

export class GraphicsInfo {
  constructor(
    public isTemplate: boolean,
    public id: number,
    public uid: string,
    public instanceTemplateId: number,
    public name: string,
    public description: string,
    public thumbnail: string,
    public sampleVideo: string,
    public startLoopMS: number,
    public endLoopMS: number,
    public durationMS: number,
    public zLayer: number,
    public fields?: GraphicsInfoField[],
    public overrideGraphicPosition?: RectangleF,
  ) {}
}
